import utils from './utils';

import auth from './auth';
import campaigns from './campaigns';
import products from './products';
const index = {
  utils,

  auth,
  campaigns,
  products,
};

export default index;